var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('h5',{staticClass:"border-line text-center",attrs:{"md":"auto"}},[_vm._v(_vm._s(_vm.title))])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }